import { render } from "./BusinessReports.vue?vue&type=template&id=e2680178&scoped=true"
import script from "./BusinessReports.vue?vue&type=script&lang=js"
export * from "./BusinessReports.vue?vue&type=script&lang=js"

import "./BusinessReports.vue?vue&type=style&index=0&id=e2680178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2680178"]])

export default __exports__